import { authenticatorApi } from "@/infrastructure/api/authenticatorApi";
import type {
  MetricsPeriod,
  ProductViewsMetrics,
  ProfileViewsMetrics,
} from "@/types/profileMetrics";
import type { WhatsappClicksMetrics } from "@/types/whatsappMetrics";

export async function getProfileViewsMetrics(periodo: MetricsPeriod) {
  const { data } = await authenticatorApi.get<ProfileViewsMetrics>(
    "/metricas/perfil/visualizacoes",
    { params: { periodo } },
  );
  return data;
}

export async function getProductViewsMetrics(periodo: MetricsPeriod) {
  const { data } = await authenticatorApi.get<ProductViewsMetrics>(
    "/metricas/produtos/visualizacoes",
    { params: { periodo } },
  );
  return data;
}

export async function getWhatsappClicksMetrics() {
  const { data } = await authenticatorApi.get<WhatsappClicksMetrics>(
    "/metricas/whatsapp/cliques",
  );
  return data;
}
